export default __webpack_public_path__ + "static/media/leader_notes.8636581d.pdf";